import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { GraficoSearchParameter } from '../shared/model/search/graficos-search-parameters.model';

@Injectable()
export class HomeService {

  urlBaseEstatisticasAPI: string;

  constructor(private http: HttpClient) {
    this.urlBaseEstatisticasAPI = `${environment.mouraAmmServerURL}/estatisticas`;
  }

  lancamentosPorMes(filtros: GraficoSearchParameter): Observable<any> {
    return this.http.get(`${this.urlBaseEstatisticasAPI}/por-mes`);
  }

  lancamentosPorAno(filtros: GraficoSearchParameter): Observable<any> {
    return this.http.get(`${this.urlBaseEstatisticasAPI}/por-ano`);
  }

  buscarQuantidadeAtendimentosPorMes(filtros: GraficoSearchParameter): Observable<any> {
    const params = this.montarHttpParams(filtros);

    return this.http.get(`${this.urlBaseEstatisticasAPI}/por-mes-qtde`, { params });
  }

  buscarQuantidadeAtendimentosPorAno(filtros: GraficoSearchParameter): Observable<any> {
    const params = this.montarHttpParams(filtros);

    return this.http.get(`${this.urlBaseEstatisticasAPI}/por-ano-qtde`, { params });
  }

  buscarQuantidadeUsuarios(): Observable<any> {
    return this.http.get(`${this.urlBaseEstatisticasAPI}/quantidade-usuarios`);
  }

  buscarQuantidadePrestadores(): Observable<any> {
    return this.http.get(`${this.urlBaseEstatisticasAPI}/quantidade-prestadores`);
  }

  buscarQuantidadeProcedimentos(): Observable<any> {
    return this.http.get(`${this.urlBaseEstatisticasAPI}/quantidade-procedimentos`);
  }

  buscarQuantidadeAtendimentos(): Observable<any> {
    return this.http.get(`${this.urlBaseEstatisticasAPI}/quantidade-atendimentos`);
  }

  /**
   * Método responsável por montar os parâmetro que serão enviados na requisição
   * @param pageable objeto com os dados da paginação.
   * @param filtros objeto com combinação dos filtros selecionados no componente.
   */
  private montarHttpParams(filtros: GraficoSearchParameter): HttpParams {

    let params = new HttpParams();

    if (filtros.ano) {
      params = params.set('ano', filtros.ano.toString());
    }

    if (filtros.usuario) {
      params = params.set('usuario', filtros.usuario.toString());
    }

    return params;
  }
}
